import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = {
  viewBox: "0 0 100% 100",
  width: "100%",
  height: "100"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("rect", {
  width: "100%",
  height: "12",
  y: "0",
  x: "70",
  fill: "#eeedf4"
}, null, -1)
const _hoisted_4 = ["x"]
const _hoisted_5 = ["x"]
const _hoisted_6 = ["x"]
const _hoisted_7 = { key: 0 }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("h4", null, "Não foi possível carregar os dados", -1)
const _hoisted_9 = [
  _hoisted_8
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Line = _resolveComponent("Line")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Line, {
      styles: _ctx.stylesBar,
      "chart-options": _ctx.chartOptions,
      "chart-data": _ctx.chartData,
      "chart-update": _ctx.chartData
    }, null, 8, ["styles", "chart-options", "chart-data", "chart-update"]),
    (_openBlock(), _createElementBlock("svg", _hoisted_2, [
      _hoisted_3,
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dataFiliation, (item) => {
        return (_openBlock(), _createElementBlock(_Fragment, { key: item }, [
          _createElementVNode("rect", {
            class: "affil-point",
            width: "12",
            height: "12",
            x: item[0].qtd >= 100 ? '98%' : item[0].qtd + '%',
            y: "0"
          }, null, 8, _hoisted_4),
          _createElementVNode("text", {
            class: "affil-text text-sm",
            "text-anchor": "middle",
            "font-family": "sans-serif",
            x: item[0].qtd >= 100 ? '98%' : item[0].qtd + '%',
            dy: "45"
          }, _toDisplayString(item[0].name), 9, _hoisted_5),
          _createElementVNode("text", {
            class: "affil-text text-xs",
            "text-anchor": "middle",
            "font-family": "sans-serif",
            x: item[0].qtd >= 100 ? '98%' : item[0].qtd + '%',
            dy: "65"
          }, " (" + _toDisplayString(item[0].started) + ") ", 9, _hoisted_6)
        ], 64))
      }), 128))
    ])),
    (_ctx.loaded && _ctx.error)
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, _hoisted_9))
      : _createCommentVNode("", true)
  ]))
}